import React from 'react';
import NoteEvent from '../../../../../../common/components/activity-events/note/NoteEvent';
import { deleteOrderTimelineNoteThunk, editOrderTimelineNoteThunk } from '../../../../../../store/thunks/orders/viewPageOrderThunks';
import { PermissionEnum } from '../../../../../../core/enums/dictionariesEnums';
import { BasicNoteEventProps } from '../../../../../../core/types/coreTypes';
import { useNoteActivityLog } from '../../../../../../common/hooks/useNoteActivityLog';

const OrderNoteEvent: React.FC<BasicNoteEventProps> = ({ id, content = '', initiator = '' }) => {
  const {
    dispatch,
    value,
    setValue,
    isEditModal,
    isConfirmationModal,
    setIsConfirmationModal,
    closeHandle,
    menuItems,
  } = useNoteActivityLog(content);

  const editHandle = () => {
    id && dispatch(editOrderTimelineNoteThunk({
      id,
      content: value.trim(),
      closeModal: closeHandle,
    }));
  };

  const deleteHandle = () => {
    id && dispatch(deleteOrderTimelineNoteThunk({
      id,
      closeModal: () => setIsConfirmationModal(false),
    }));
  };

  return (
    <NoteEvent
      content={content}
      menuItems={menuItems}
      value={value}
      setValue={setValue}
      isEditModal={isEditModal}
      closeEditModal={closeHandle}
      editHandle={editHandle}
      isConfirmationModal={isConfirmationModal}
      setIsConfirmationModal={setIsConfirmationModal}
      deleteHandle={deleteHandle}
      initiator={initiator}
      permission={PermissionEnum.OrderEditDeleteNotesOfOtherUsersInActivityLog}
    />
  );
};

export default OrderNoteEvent;
